import { useCallback, useEffect, useRef, useState } from 'react';
import {
    checkValidDate,
    getCurrentDay,
    getCurrentHour,
    getCurrentMinute,
    getCurrentMonth,
    getCurrentYear,
    getDay,
    getHour,
    getMinute,
    getMonth,
    getYear,
} from '~/utils/datetime';
import { findIndexByName, findNameByIndex } from '~/utils/options';
import styles from './Add.module.scss';
import clsx from 'clsx';
import Select from '~/components/select/Select';
import moneyApi from '~/api/moneyApi';
import { CommonHeader } from '~/components';
import {
    optionsDay,
    optionsHour,
    optionsMinute,
    optionsMonth,
    optionsType,
    optionsYear,
} from '~/constants/options';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { isSuccess } from '~/utils/api';
import { genUniqueKey } from '~/utils/common';
import { actions, useStore } from '~/store';

function Add() {
    const navigate = useNavigate();
    const refDay = useRef();
    const refMonth = useRef();
    const refYear = useRef();
    const refHour = useRef();
    const refMinute = useRef();
    const refType = useRef();
    const refPlace = useRef();

    const { editId, cloneId } = useParams();
    const [showNote] = useState(false);
    const refMoney = useRef(null);
    const refNote = useRef(null);

    const [day, setDay] = useState(
        findIndexByName(optionsDay, getCurrentDay()),
    );
    const [month, setMonth] = useState(
        findIndexByName(optionsMonth, getCurrentMonth()),
    );
    const [year, setYear] = useState(
        findIndexByName(optionsYear, getCurrentYear()),
    );
    const [hour, setHour] = useState(
        findIndexByName(optionsHour, getCurrentHour()),
    );
    const [minute, setMinute] = useState(
        findIndexByName(optionsMinute, getCurrentMinute()),
    );
    const [type, setType] = useState(0);
    const [place, setPlace] = useState(0);

    const [name, setName] = useState('');
    const [note] = useState('');
    const [amount, setAmount] = useState(0);

    const [optionsPlace, setOptionsPlace] = useState([]);
    const [state, dispatch] = useStore();
    const { moneys, places, tripId } = state;

    const onChangeOptions = useCallback((index, name) => {
        switch (name) {
            case 'day':
                setDay(index);
                break;
            case 'month':
                setMonth(index);
                break;
            case 'year':
                setYear(index);
                break;
            case 'hour':
                setHour(index);
                break;
            case 'minute':
                setMinute(index);
                break;
            case 'type':
                setType(index);
                break;
            case 'place':
                setPlace(index);
                break;
            default:
                throw new Error('invalid name');
        }
    }, []);

    const handleCancel = () => {
        navigate('/moneys');
    };
    const handleSave = () => {
        if (place < 0 || place > places.length - 1) {
            toast.warn('Chưa chọn plcace kìa');
            return;
        }

        const dd = findNameByIndex(optionsDay, day);
        const MM = findNameByIndex(optionsMonth, month);
        const yyyy = findNameByIndex(optionsYear, year);
        const HH = findNameByIndex(optionsHour, hour);
        const mm = findNameByIndex(optionsMinute, minute);
        const typeName = findNameByIndex(optionsType, type);
        const placeId = places[place].id;
        const placeName = places[place].name;
        // console.log('day', dd);
        // console.log('month', MM);
        // console.log('year', yyyy);
        // console.log('hour', HH);
        // console.log('minute', mm);
        // console.log('type', typeName);
        // console.log('place', placeId);
        // console.log('amount', amount);
        // console.log('name', name);
        // console.log('note', note);
        const datetime = `${yyyy}-${MM}-${dd} ${HH}:${mm}`;

        if (parseInt(amount) === 0) {
            toast.warn('Chưa nhập số tiền kìa');
            return;
        }

        if (!checkValidDate(dd, MM, yyyy)) {
            toast.warn(`${dd}-${MM}-${yyyy} ko hợp lệ`);
            return;
        }

        if (editId) {
            // sửa
            dispatch(
                actions.updateMoney({
                    id: editId,
                    datetime,
                    amount,
                    type: typeName,
                    name,
                    place: placeId,
                    placeId,
                    placeName,
                    note,
                    tripId,
                }),
            );
            dispatch(actions.setLoading2({ loading2: true }));
            moneyApi
                .edit({
                    id: editId,
                    datetime,
                    amount,
                    type: typeName,
                    name,
                    place: placeId,
                    note,
                    tripId,
                })
                .then((res) => {
                    // console.log('res', res);
                    if (isSuccess(res)) {
                        toast.success('Sửa thành công');
                    } else {
                        toast.error(
                            'Sửa thất bại. ' + JSON.stringify(res.data),
                        );
                    }
                    dispatch(actions.setLoading2({ loading2: false }));
                })
                .catch((error) => {
                    console.log(error);
                    toast.error(JSON.stringify(error));
                    dispatch(actions.setLoading2({ loading2: false }));
                });
            navigate(`/moneys/${editId}`);
        } else {
            // thêm
            const newId = genUniqueKey();
            dispatch(
                actions.insertMoney({
                    id: newId,
                    datetime,
                    amount,
                    type: typeName,
                    name,
                    place: placeId,
                    placeId,
                    placeName,
                    note,
                    tripId,
                }),
            );

            // call api
            dispatch(actions.setLoading2({ loading2: true }));
            moneyApi
                .insert({
                    id: newId,
                    datetime,
                    amount,
                    type: typeName,
                    name,
                    place: placeId,
                    note,
                    tripId,
                })
                .then((res) => {
                    // console.log('res', res);
                    if (isSuccess(res)) {
                        toast.success('Thêm mới thành công');
                    } else {
                        toast.error(
                            'Thêm thất bại. ' + JSON.stringify(res.data),
                        );
                    }
                    dispatch(actions.setLoading2({ loading2: false }));
                })
                .catch((error) => {
                    console.log(error);
                    toast.error(JSON.stringify(error));
                    dispatch(actions.setLoading2({ loading2: false }));
                });

            navigate(`/moneys/${newId}`);
        }
    };

    const handleOnChangeName = (e) => {
        setName(e.target.value);
    };

    // const handleOnChangeNote = (e) => {
    //     setNote(e.target.value);
    // };

    const handleOnChangeAmount = (e) => {
        const str = e.target.value;
        if (str === '') {
            setAmount(0);
        } else {
            setAmount(parseInt(str));
        }
    };

    const handleFocus = (event) => event.target.select();

    const handleOnBlurAmount = (e) => {
        e.target.value = amount;
    };

    useEffect(() => {
        if (refNote && refNote.current) refNote.current.focus();
    }, [showNote]);

    useEffect(() => {
        refMoney.current.focus();

        console.log('editId', editId);
        console.log('cloneId', cloneId);

        const initMoneyId = editId ? editId : cloneId;
        const initMoney = moneys.find((m) => m.id === initMoneyId);
        if (initMoney) {
            console.log('initMoney', initMoney);

            const dayIndex = findIndexByName(
                optionsDay,
                getDay(initMoney.datetime),
            );
            refDay.current.changeSelectedIndex(dayIndex);
            setDay(dayIndex);

            const monthIndex = findIndexByName(
                optionsMonth,
                getMonth(initMoney.datetime),
            );
            refMonth.current.changeSelectedIndex(monthIndex);
            setMonth(monthIndex);

            const yearIndex = findIndexByName(
                optionsYear,
                getYear(initMoney.datetime),
            );
            refYear.current.changeSelectedIndex(yearIndex);
            setYear(yearIndex);

            const hourIndex = findIndexByName(
                optionsHour,
                getHour(initMoney.datetime),
            );
            refHour.current.changeSelectedIndex(hourIndex);
            setHour(hourIndex);

            const minuteIndex = findIndexByName(
                optionsMinute,
                getMinute(initMoney.datetime),
            );
            refMinute.current.changeSelectedIndex(minuteIndex);
            setMinute(minuteIndex);

            const typeIndex = findIndexByName(optionsType, initMoney.type);
            refType.current.changeSelectedIndex(typeIndex);
            setType(typeIndex);

            setAmount(initMoney.amount);
            setName(initMoney.name);

            const placeIndex = findIndexByName(
                optionsPlace,
                initMoney.placeName,
            );
            refPlace.current.changeSelectedIndex(placeIndex);
            setPlace(placeIndex);
        }
    }, [editId, cloneId, tripId, moneys, optionsPlace]);

    useEffect(() => {
        const newOptionsPlace = places.map((place) => ({
            name: place.name,
        }));
        setOptionsPlace(newOptionsPlace);
    }, [places]);

    return (
        <div className={styles.wrapper}>
            <CommonHeader
                title={editId ? 'SỬA CHI TIÊU' : 'THÊM MỚI CHI TIÊU'}
            />
            <div className={styles.new}>
                <div className={clsx(styles.row, styles.datetime)}>
                    <div className={styles.date}>
                        <div className={styles.day}>
                            <Select
                                options={optionsDay}
                                intiSelectedIndex={day}
                                onChange={onChangeOptions}
                                title={'dd'}
                                name="day"
                                ref={refDay}
                            ></Select>
                        </div>
                        <div className={styles.separator}>/</div>
                        <div className={styles.month}>
                            <Select
                                options={optionsMonth}
                                intiSelectedIndex={month}
                                onChange={onChangeOptions}
                                title={'MM'}
                                name="month"
                                ref={refMonth}
                            ></Select>
                        </div>
                        <div className={styles.separator}>/</div>
                        <div className={styles.year}>
                            <Select
                                options={optionsYear}
                                intiSelectedIndex={year}
                                onChange={onChangeOptions}
                                title={'yyyy'}
                                name="year"
                                ref={refYear}
                            ></Select>
                        </div>
                    </div>
                    <div className={styles.time}>
                        <div className={styles.hour}>
                            <Select
                                options={optionsHour}
                                intiSelectedIndex={hour}
                                onChange={onChangeOptions}
                                title={'HH'}
                                name="hour"
                                ref={refHour}
                            ></Select>
                        </div>
                        <div className={styles.separator}>:</div>
                        <div className={styles.minute}>
                            <Select
                                options={optionsMinute}
                                intiSelectedIndex={minute}
                                onChange={onChangeOptions}
                                title={'mm'}
                                name="minute"
                                ref={refMinute}
                            ></Select>
                        </div>
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.place}>
                        <div className={styles.label}>Tỉnh / Thành Phố</div>
                        <div className={styles.place}>
                            <Select
                                options={optionsPlace}
                                intiSelectedIndex={place}
                                onChange={onChangeOptions}
                                addNew
                                markdown
                                name="place"
                                ref={refPlace}
                            ></Select>
                        </div>
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.type}>
                        <Select
                            options={optionsType}
                            intiSelectedIndex={type}
                            onChange={onChangeOptions}
                            markdown
                            name="type"
                            ref={refType}
                        ></Select>
                    </div>
                    <div className={styles.amount}>
                        <input
                            placeholder="100"
                            ref={refMoney}
                            type="number"
                            value={amount}
                            onChange={handleOnChangeAmount}
                            onFocus={handleFocus}
                            onBlur={handleOnBlurAmount}
                        />
                        <div className={styles.label}>k</div>
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.name}>
                        <input
                            placeholder="Tên quán / khách sạn ..."
                            type="text"
                            value={name}
                            onChange={handleOnChangeName}
                        ></input>
                    </div>
                </div>

                <div className={styles.actions}>
                    <button className={styles.cancel} onClick={handleCancel}>
                        Hủy
                    </button>
                    <button className={styles.save} onClick={handleSave}>
                        Lưu
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Add;
